import React from 'react';
import { TColumn } from './types';
import { useTranslation } from 'react-i18next';
import { authorize } from 'src/utils/auth';
import {
    DEVELOPER_LEVEL_ACCESS,
    GROUP_LEVEL_ACCESS,
} from 'src/components/access';

interface IUserStoresRow {
    column: TColumn;
    item: any;
}

export const UserStoresRow = ({ item }: IUserStoresRow) => {
    const { t } = useTranslation();

    if (!item?.accessLevel && !item.stores) {
        return <span>- - -</span>;
    }

    if (
        authorize(item?.accessLevel, DEVELOPER_LEVEL_ACCESS, GROUP_LEVEL_ACCESS)
    ) {
        return <span>Global</span>;
    }

    if (item.stores && Array.isArray(item.stores)) {
        if (item.stores.length === 0) {
            return <span>- - -</span>;
        }

        if (item.stores.length > 3) {
            return (
                <div style={{ minWidth: '25ch' }}>
                    {item.stores[0].name}
                    <br />
                    {item.stores[1].name}
                    <br />
                    {t('and')} {item.stores.length - 2} {t('more')}...
                </div>
            );
        }

        return (
            <div style={{ minWidth: '25ch' }}>
                {item.stores.map((store: any, index: number) => (
                    <React.Fragment key={store._id || index}>
                        {store.name}
                        {index < item.stores.length - 1 && <br />}
                    </React.Fragment>
                ))}
            </div>
        );
    }

    return <span>- - -</span>;
};
